import './_Sider.scss';
import { Layout, Button } from '@arkas/coreui';
import { applicationState } from '@/states/applicationState';
import AppMenu from '../Menu/Menu';
import appModel from '@/states/appModel';
import ArkasLogo from '@/assets/images/ArkasLogo.svg';
import classnames from 'classnames';
import commonResources from '@/common/resources/common';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { MenuItemDto } from '@emutabakat-types/app';
import menuItems from '../Menu/menuItems';
import musteriMenuItems from '../Menu/musteriMenuItems';
import React from 'react';
import { UserDto } from '@emutabakat-types/anaveri';

const { Sider } = Layout;

interface AppSiderProps {
  collapseSider: boolean;
  topMenu: boolean;
  isSmallScreen: boolean;
  toggleSider: Function;
  currentUser: UserDto;
}

interface AppSiderStates {
  menuItems: MenuItemDto[];
  musteriMenuItems: MenuItemDto[];
  backUpItems: MenuItemDto[];
  searching: boolean;
}

/**
 * AppSider Component
 */
class AppSider extends React.Component<AppSiderProps, AppSiderStates> {
  constructor(props: AppSiderProps) {
    super(props);
    this.state = {
      menuItems,
      musteriMenuItems,
      backUpItems: menuItems,
      searching: false
    };
  }

  componentDidMount() {}

  searchSubItems(item: MenuItemDto, keyword: string) {
    const mainItem: MenuItemDto = {
      icon: item.icon,
      title: item.title,
      items: [],
      key: item.key
    };

    if (item.items) {
      for (let i = 0; i < item.items.length; i++) {
        const current = item.items[i];
        if (current.items && current.items.length > 0) {
          const subItem = this.searchSubItems(current, keyword);
          if (subItem) {
            mainItem.items = [...mainItem.items!, subItem];
          }
        }
      }

      if (mainItem.items && mainItem.items.length > 0) {
        return mainItem;
      }
    }
    return null;
  }

  searchItems = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { currentUser } = this.props;
    const { backUpItems } = this.state;

    let keyword = event.target.value;

    const menuItems = currentUser.isArkasUser ? backUpItems : musteriMenuItems;
    let searchedItems: Array<MenuItemDto> = [];
    keyword = keyword.trim();
    if (keyword) {
      keyword = keyword.toLowerCase();
      for (let i = 0; i < menuItems.length; i++) {
        const currentItem = menuItems[i];
        if (currentItem.items && currentItem.items.length > 0) {
          const temp = this.searchSubItems(currentItem, keyword);
          if (temp) {
            searchedItems = [...searchedItems, temp];
          }
        }
      }
      this.setState({
        menuItems: searchedItems,
        searching: true
      });
    } else {
      this.setState({
        menuItems: currentUser.isArkasUser ? backUpItems : musteriMenuItems,
        searching: false
      });
    }
  };

  toggleSiderWithButton = () => {
    const { toggleSider } = this.props;
    toggleSider(true);
  };

  detectSmallScreen = (isSmallScreen: boolean) => {
    appModel.setDeviceSize(isSmallScreen);
    if (isSmallScreen) {
      appModel.setCollapseSider(true);
    } else {
      appModel.setCollapseSider(false);
    }
  };

  render() {
    const { menuItems, searching } = this.state;
    const {
      collapseSider,
      topMenu,
      isSmallScreen,
      toggleSider,
      currentUser
    } = this.props;
    const items = currentUser.isArkasUser ? menuItems : musteriMenuItems;
    return (
      <Sider
        className={classnames(
          'sider',
          !isSmallScreen && topMenu && 'hide-sider',
          collapseSider ? isSmallScreen && 'hide-sider' : 'full-sider'
        )}
        collapsed={collapseSider && !isSmallScreen}
        breakpoint="lg"
        onBreakpoint={this.detectSmallScreen}
      >
        <div className="sider-header">
          {isSmallScreen && (
            <div className="sider-toggler">
              <Button
                ghost={true}
                className="sider-toggle-button"
                icon="menu-fold"
                onClick={this.toggleSiderWithButton}
              />
            </div>
          )}
          <Link to="/">
            <div
              className={classnames('sider-logo', isSmallScreen && 'mobile')}
            >
              <ArkasLogo />
            </div>
            <h1
              className={classnames('sider-title', collapseSider && 'hidden')}
            >
              E&#x2011;
              <FormattedMessage id={commonResources.mutabakat.id} />
            </h1>
          </Link>
        </div>

        {(isSmallScreen || !topMenu) && (
          <div className={classnames('sider-content')}>
            <AppMenu
              mode={'inline'}
              theme={'dark'}
              collapsed={collapseSider && !isSmallScreen}
              menuItems={items}
              toggleSider={toggleSider}
              searching={searching}
            />
          </div>
        )}
      </Sider>
    );
  }
}

const mapStateToProps = (state: applicationState) => {
  return {
    isSmallScreen: state.appModel.isSmallScreen,
    topMenu: state.appModel.topMenu,
    currentUser: state.kullaniciModel.currentUser
  };
};
export default connect(mapStateToProps)(AppSider);
